import React, { useState, useEffect, Component, useDebugValue } from 'react'
import { Link } from 'react-router-dom';

//Redux
import { connect } from 'react-redux';
import { userActions } from '../_actions';

const Footer = (props) => {
    const { user } = props;
    try{
        return (
            <footer>
                <div className="user-details-row1">
                    <b>Logged in As:</b> {`${user.firstName} ${user.lastName} ( ${user.role.charAt(0).toUpperCase() + user.role.replace("_", " ").substr(1).toLowerCase()} )`}
                </div>
                <div className="user-details-row2">
                    <b>Account:</b>  {`${user.companyName} ${user.accountId}`}
                </div>
                <p><a href="https://www.supernova.inc/policy.html" target='_blank'>Terms Of Service</a></p>
                <p>All rights reserved © Supernova.inc <span>Version 1.0 | Build Number 250</span></p>
            </footer>
        )
    }
    catch(e){
        window.location.reload(false);
    }
}

const mapState = state => ({
    user : state.users.current,
})

const actionCreators = {
}

const connectedFooter = connect(mapState, actionCreators)(Footer);

export { connectedFooter as Footer };
